import  { useContext, useEffect, useState } from "react";
import "../SafeAggrement/SafeAggrement.scss";
import "../PPMContent/PPMContent.scss";
import "./CorporateGovernancePolicy.scss";

import parser from "html-react-parser";
import { useNavigate } from "react-router-dom";
import { Context } from "../../contextApi/contextProvider";
import { cmsPrivateContent } from "../../utils/cmscontent/cms";
import { MarkDocumentRead } from "../../utils/Api/api";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";


const CorporateGovernancePolicy = () => {
  const navigator = useNavigate();
  const loaction = useGeoLocation();
  const { userLoginData,  accessDoc } =
    useContext(Context);
  const token = JSON.parse(localStorage.getItem("access_token") as string);

  const [htmlStr, setHtmlStr] = useState<any>([]);
  const contents = [
    "1. OBJECTIVE ",
    "2. STRUCTURE & RESPONSIBILITIES OF THE BOARD ",
    "3. EDUCATION, QUALIFICATIONS & STANDARDS FOR THE BOARD ",
    "4. MEETINGS & DECISION-MAKING ",
    "5. BOARD DUTIES ",
    "6. CHAIRMAN ROLE ",
    "7. CEO ROLE ",
    "8. COO ROLE ",
    "9. CONFLICT OF INTEREST ",
    "10. ANTI-BRIBERY & ANTICORRUPTION ",
    "11. SAFE, SHARE & STAKE HOLDER RIGHTS & DUTIES ",
    "12. RISK CONTROL",
    "13. DISCLOSURE AND TRANSPARENCY ",
    "14. CODE OF CONDUCT AND ETHICAL STANDARDS ",
    "15. CORPORATE & ENVIRONMENTAL SOCIAL RESPONSIBILITY ",
    "16. INFORMATION SECURITY & DATA PROTECTION",
    "17. BUSINESS CONTINUITY & OPERATIONAL RESILIENCE ",
    "18. AUDIT, COMPLIANCE & ASSURANCE ",
    "19. Board Committees and Delegated Functions ",
    "20. RISK REGISTER AND CLASSIFICATION MATRIX ",
    "21. LEGAL ENTITY GOVERNANCE & JURISDICTIONAL COMPLIANCE ",
    "22. EQUITY GOVERNANCE AND CAP TABLE OVERSIGHT ",
    "23. POLICY REVIEW, AMENDMENT, AND VERSION CONTROL ",
  ];

  const fetchCmsContent = async () => {
    const response = await cmsPrivateContent({
      post_id: "12146",
      lat: loaction.coordinates.lat,
      log: loaction.coordinates.lng,
    });
    setHtmlStr(response);
  };
  useEffect(() => {
    if (userLoginData.status == 200 && accessDoc["12146"] !== "de") {
      if (accessDoc["12146"] == "ALLOWED") {
        readDoc();
        fetchCmsContent();
      } else {
        navigator("/");
      }
    } else if (userLoginData.status == 404) {
      navigator("/");
    } else if (token === "" || token === null || token === undefined) {
      navigator("/");
    }

    document.title = "TICCA | Corporate Governance Policy";
    window.scrollTo(0, 0);
  }, [userLoginData.status, accessDoc]);

  const readDoc = async () => {
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "12146",
      });
    } catch (error) {}
  };

  return (
    <>
    {htmlStr.length &&  <div className="watermaring-main-dev">
        <img
          src="https://public.ticca.com/images/svg/Watermark_Business_Summary.svg"
          alt="logo"
        />
        <p>
          Commercial in Confidence <br />
          Content under NDA.
          <br /> {userLoginData?.email}
        </p>
      </div> }
      {htmlStr.length <= 2 && (
        <div
          style={{ marginTop: "100px" }}
          className=" page-shimmer-container-co"
        >
          {Array.from({ length: 20 }).map((_, index) => (
            <div className="page-shimmer-co" key={index}></div>
          ))}
        </div>
      )}
      {htmlStr.length > 2 && (
        <div style={{ marginTop: "100px" }} className="shareholder-main-dev">
          <div className="safe-agreement-container">
            {/* Header */}
            <div className="header">
              <p className="cor-title">Corporate Governance Policy</p>
            </div>

            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>TABLE OF CONTENTS</h2>
              <ul>
                {contents.map((item, index) => (
                  <li key={index}>
                    <div className="line">
                      <span className="title">{item}</span>
                      <span className="dots"></span>
                      <span className="page-number">{3 + index}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="safe-agreement-container">
            {htmlStr.length > 1 &&
              htmlStr.slice(1).map((elem: any, index: number) => (
                <div
                  key={`table-of-contentsr-${index}`}
                  className="safe-agreement-cms-container"
                >
                  {parser(elem)}
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

// 🧠 Prevent re-renders unless props actually change
export default CorporateGovernancePolicy;
